import React from "react";
import {TypeAheadOptionsProps} from "../props";
import {TypeAheadOptions} from "./TypeaheadOptions";


export const TypeAheadSuggestions = ({filteredOptions, search, notFoundText, handleSuggestionClick, display}: TypeAheadOptionsProps) => {
  if (!display) {
    return null;
  }
  return (
    <div
      className='typeahead-search__suggestions-dropdown'
      id='typeahead-search-suggestions'
      role='listbox'
    >
      <TypeAheadOptions
        filteredOptions={filteredOptions}
        search={search}
        notFoundText={notFoundText}
        handleSuggestionClick={handleSuggestionClick}/>
    </div>
  )
};
